module.exports = __webpack_public_path__ + "media/images/hamburger-effe7144.svg";